import { render } from "./EmployeeTrackerLogCard.vue?vue&type=template&id=65916948&scoped=true"
import script from "./EmployeeTrackerLogCard.vue?vue&type=script&lang=js"
export * from "./EmployeeTrackerLogCard.vue?vue&type=script&lang=js"

import "./tracker-log-card.scss?vue&type=style&index=0&id=65916948&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65916948"]])

export default __exports__